module.exports = __webpack_public_path__ + "static/img/pic1@2x.0c8566c4.png";